<template>
  <div class="user-profile">
    <h1>Benutzerprofil</h1>
    <div v-if="user">
      <p><strong>Benutzername:</strong> {{ user.username }}</p>
      <p><strong>E-Mail-Adresse:</strong> {{ user.email }}</p>
    </div>
    <div v-else>
      <p>Lade Benutzerdaten...</p>
    </div>
    <div v-if="user.vehicle">
      <h2>Zugeordnetes Fahrzeug</h2>
      <p><strong>Hersteller:</strong> {{ user.vehicle.manufacturer }}</p>
      <p><strong>Modell:</strong> {{ user.vehicle.model }}</p>
      <p><strong>Variante:</strong> {{ user.vehicle.variant }}</p>
      <p><strong>Batteriegröße:</strong> {{ user.vehicle.batterysize }} kWh</p>
    </div>
    <div v-else>
      <p>Kein Fahrzeug zugeordnet.</p>
    </div>
    <button @click="logout" class="logout-button">Logout</button>
  </div>
</template>

<script>
export default {
  computed: {
    user () {
      return this.$store.getters.getUser // Zugriff auf die Benutzerdaten
    },
    vehicle () {
      return this.user.vehicle || 'No vehicle assigned' // Fallback für `vehicle`
    }
  },
  methods: {
    logout () {
      // Logout-Logik implementieren
      alert('Erfolgreich ausgeloggt!')
      this.$router.push({ name: 'WelcomePage' })
    }
  }
}
</script>

<style scoped>
.user-profile {
  padding: 20px;
}

.logout-button {
  margin-top: 20px;
}
</style>
